<template>
  <section class="mt-8">
    <div>
      <div class="card bg-root-1 lg:pt-8 pt-4 pb-3 lg:pb-6 lg:px-8 px-5">
        <p class="text-root-15 text-sm lg:text-lg font-semibold">
          Swap Details
        </p>
      </div>
      <div class="card2 bg-root-1 lg:px-8 px-5 py-6">
        <div
          class="px-6 py-3.5 bg-blue-70 rounded-lg grid grid-cols-6 mb-6 gap-x-2 items-center"
        >
          <p class="text-blue-90 text-xs lg:text-sm font-medium col-span-2">
            You send:
          </p>
          <div class="flex items-center flex-row col-span-4 gap-x-1 gap-y-1">
            <currency-icon
              :currency="fromSwapAssetDetails.shortName"
              size="lg:h-8 lg:w-8 h-6 w-6"
            />
            <p
              class="font-semibold text-blue-11 text-sm lg:text-base lg:ml-1.5"
            >
              ≈
              {{
                addComma(swapFormDetails.enteredAmount.toString()) +
                ' ' +
                fromSwapAssetDetails.currency
              }}
            </p>
            <div
              class="px-2 py-0.5 bg-blue-80 text-white uppercase font-semibold text-8px lg:text-10px text-center rounded-lg lg:ml-4"
            >
              {{ fromSwapAssetDetails.networkShortName }}
            </div>
          </div>
        </div>
        <div
          class="px-6 py-3.5 bg-blue-70 rounded-lg grid grid-cols-6 mb-6 gap-x-1 items-center"
        >
          <p class="text-blue-90 text-xs lg:text-sm font-medium col-span-2">
            You get:
          </p>
          <div class="flex items-center flex-row col-span-4 gap-y-1">
            <currency-icon
              :currency="toSwapAssetDetails.shortName"
              size="lg:h-8 lg:w-8 h-6 w-6"
            />
            <p
              class="font-semibold text-blue-11 text-sm lg:text-base lg:ml-1.5"
            >
              ≈
              {{
                addComma(swapFormDetails.recipientAmount.toString()) +
                ' ' +
                toSwapAssetDetails.currency
              }}
            </p>
            <div
              class="px-2 py-0.5 bg-blue-80 text-white uppercase font-semibold text-8px lg:text-10px text-center rounded-lg lg:ml-4"
            >
              {{ toSwapAssetDetails.networkShortName }}
            </div>
          </div>
        </div>
        <div
          class="px-6 py-3.5 bg-blue-70 rounded-lg lg:grid lg:grid-cols-6 mb-6 flex items-center"
        >
          <p class="text-blue-90 text-xs lg:text-sm font-medium col-span-2">
            Recipient address:
          </p>
          <div class="flex items-center col-span-4">
            <p
              style="word-break: break-all"
              class="font-semibold text-blue-90 text-sm text-center lg:text-left"
            >
              {{ maskID(swapFormDetails.walletAddress) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-button
      v-if="currentConfirmationScreenStep === 1"
      @click="paymentMadeHandler"
      :loading="isLoading"
      :disabled="isLoading"
      class="mt-8 w-full bg-primary text-white lg:text-base text-sm font-normal lg:py-5 py-2.5 rounded-lg flex justify-center items-center cursor-pointer"
    >
      Payment Made
    </el-button>
  </section>
</template>

<script>
import {
  GetCurrencyCountry,
  ParseMoneyAll,
  MaskWalletAddressTwo,
  AddComma
} from '@/utils/helpers.js'
import swapPairAssetsDetails from '@/mixins/bridge.js'
export default {
  mixins: [swapPairAssetsDetails],
  data () {
    return {
      isLoading: false,
      intervalId: '',
      count: 0,
      maxWaitTime: 900
    }
  },
  components: {
    CurrencyIcon: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  computed: {
    currentConfirmationScreenStep: {
      get: function () {
        return this.$store.state.bridge.currentConfirmationScreenStep
      }
    },
    swapFormDetails () {
      return this.$store.state.bridge.swapFormDetails
    },
    initiatedSwapDetails () {
      return this.$store.state.bridge.initiatedSwapDetails
    }
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Deposit Address Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    nextStep () {
      this.$emit('nextStep')
    },
    paymentMadeHandler () {
      this.isLoading = true
      const swappedPairId = this.initiatedSwapDetails.swap.id
      this.getSwappedPairDetailsById(swappedPairId)
      this.intervalId = setInterval(() => {
        this.count += 3
        this.getSwappedPairDetailsById(swappedPairId)
      }, 3000)
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    addComma (val) {
      return AddComma(val)
    }
  },
  watch: {
    '$store.state.bridge.swappedPairDetailsById.swap.status': function (
      newValue
    ) {
      if (newValue === 'processing') {
        this.isLoading = false
        clearInterval(this.intervalId)
        this.nextStep()
        this.nextStep()
      }
      if (newValue === 'awaiting_business_approval') {
        this.isLoading = false
        clearInterval(this.intervalId)
        this.nextStep()
      }
    },
    count (newVal) {
      if (newVal === this.maxWaitTime) {
        this.isLoading = false
        this.$message({
          showClose: true,
          message: 'Deposit not received',
          type: 'error'
        })
        clearInterval(this.intervalId)
      }
    },
    immediate: true
  },
  destroyed () {
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);
  border: 1px solid #e4e4e7;
  border-radius: 16px 16px 0px 0px;
}
.card2 {
  border-radius: 0px 0px 16px 16px;
  border: 1px solid #e4e4e7;
}
</style>
